import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { WhatIfSection } from './components/WhatIfSection';
import { PainSection } from './components/PainSection';
import { ReadySection } from './components/ReadySection';
import { SystemIntro } from './components/SystemIntro';
import { ModulesSection } from './components/ModulesSection';
import { PreviewSection } from './components/PreviewSection';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const PIXEL_ID = '1567873378463745';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3ud1e95yxri91">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3udkmtw2p4uae" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory" data-id="element-2" data-mp="86w3omoglxy7">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="3gm61vjp8aj0p" />}
        <main data-id="element-4" data-mp="3gja8m8obsiil">
          <Hero data-id="element-5" data-mp="3bmbevr8kqdkx" />
          <WhatIfSection data-id="element-6" data-mp="3bmti57tnls2c" />
          <PainSection data-id="element-7" data-mp="3bnmh3mmdfd9x" />
          <ReadySection data-id="element-8" data-mp="3bo4lj6j6sxsx" />
          <SystemIntro data-id="element-9" data-mp="3qb7hv9vrx0eo" />
          <ModulesSection data-id="element-10" data-mp="3qbpkqpcxycvk" />
          <PreviewSection data-id="element-11" data-mp="3qbzcoihjqu3w" />
          <BonusSection data-id="element-12" data-mp="3qdajkr6aghz8" />
          <BenefitsSection data-id="element-13" data-mp="3lkr4fprydesb" />
          <PricingSection data-id="element-14" data-mp="3ljg11r2f691q" />
          <Guarantee data-id="element-15" data-mp="3lj69w05n1vug" />
          <Testimonials data-id="element-16" data-mp="3limqsg4951eu" />
          <FAQ data-id="element-17" data-mp="2xud9nrhzh1u1" />
          <FinalCTA data-id="element-18" data-mp="2xtv6sc0tfpd5" />
        </main>
        <Footer data-id="element-19" data-mp="2xt253pgprq1v" />
      </div>
    </>;
}